export * from '../src/composites/wui-icon-button/index.js';
//# sourceMappingURL=wui-icon-button.js.map